module.exports = __webpack_public_path__ + "img/Clipboard-Done.bf62f5a6.svg";